__turbopack_context__.v({
  "completed": "VisualHintInfo-module-scss-module__FtahJa__completed",
  "crossline": "VisualHintInfo-module-scss-module__FtahJa__crossline",
  "crosslineItemInfo": "VisualHintInfo-module-scss-module__FtahJa__crosslineItemInfo",
  "flatCount": "VisualHintInfo-module-scss-module__FtahJa__flatCount",
  "header": "VisualHintInfo-module-scss-module__FtahJa__header",
  "itemDescription": "VisualHintInfo-module-scss-module__FtahJa__itemDescription",
  "itemDescriptionFlat": "VisualHintInfo-module-scss-module__FtahJa__itemDescriptionFlat",
  "itemInfo": "VisualHintInfo-module-scss-module__FtahJa__itemInfo",
  "itemInfoFlat": "VisualHintInfo-module-scss-module__FtahJa__itemInfoFlat",
  "itemInfoFlatCount": "VisualHintInfo-module-scss-module__FtahJa__itemInfoFlatCount",
  "itemInfoFlatPrice": "VisualHintInfo-module-scss-module__FtahJa__itemInfoFlatPrice",
  "itemInfoRooms": "VisualHintInfo-module-scss-module__FtahJa__itemInfoRooms",
  "itemTitle": "VisualHintInfo-module-scss-module__FtahJa__itemTitle",
  "itemTitleFlat": "VisualHintInfo-module-scss-module__FtahJa__itemTitleFlat",
  "reservedItemDesc": "VisualHintInfo-module-scss-module__FtahJa__reservedItemDesc",
  "reservedItemTitle": "VisualHintInfo-module-scss-module__FtahJa__reservedItemTitle",
  "root": "VisualHintInfo-module-scss-module__FtahJa__root",
});
